module.exports = __webpack_public_path__ + "img/ysxq_top_pic.db5e5aa3.png";